import { createContext } from '@chakra-ui/react-utils';

import type {
  PercentageBreakdownItem,
  PercentageBreakdownSize,
  PercentageBreakdownVariant,
} from './types';

export type PercentageBreakdownContextValue = {
  data: PercentageBreakdownItem[];
  size?: PercentageBreakdownSize;
  variant?: PercentageBreakdownVariant;
  maxTotal?: number;
};

export const [PercentageBreakdownProvider, usePercentageBreakdownContext] =
  createContext<PercentageBreakdownContextValue>({
    name: 'PercentageBreakdownContext',
    errorMessage:
      'usePercentageBreakdownContext: `context` is undefined. Seems you forgot to wrap all percentage breakdown components within `<PercentageBreakdown />`',
  });
